import { ColorScheme } from '@blocksuite/affine/model';
import { createSignalFromObservable } from '@blocksuite/affine-shared/utils';
import type { Signal } from '@preact/signals-core';
import { Entity, LiveData } from '@toeverything/infra';

import {
  getPresetColorScheme,
  isPresetTheme,
} from '../../theme-presets/presets';

const resolveColorScheme = (theme?: string): ColorScheme => {
  if (theme === 'dark') return ColorScheme.Dark;
  if (theme === 'light') return ColorScheme.Light;
  if (theme && isPresetTheme(theme)) {
    return getPresetColorScheme(theme) === 'dark'
      ? ColorScheme.Dark
      : ColorScheme.Light;
  }
  return ColorScheme.Light;
};

export class AppTheme extends Entity {
  theme$ = new LiveData<string | undefined>(undefined);

  themeSignal: Signal<ColorScheme>;

  constructor() {
    super();
    const { signal, cleanup } = createSignalFromObservable<ColorScheme>(
      this.theme$.map(theme => resolveColorScheme(theme)),
      ColorScheme.Light
    );
    this.themeSignal = signal;
    this.disposables.push(cleanup);
  }
}
